import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { mangaList, mangaCategories } from "@/mocks/manga";

const articleCoverImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20cover%20young%20martial%20artist%20black%20hair%20red%20robes%20mystical%20flames%2C%20dramatic%20golden%20crimson%20lighting%2C%20detailed%20illustration%2C%20dynamic%20composition%2C%20clean%20gradient%20background&width=800&height=1000&seq=article-cover-01&orientation=portrait",
  2: "https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20young%20couple%20school%20uniforms%20cherry%20blossom%20trees%2C%20soft%20pink%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20beautiful%20anime%20art%2C%20delicate%20details%2C%20clean%20white%20background&width=800&height=1000&seq=article-cover-02&orientation=portrait",
  3: "https://readdy.ai/api/search-image?query=Action%20manga%20cover%20silver-haired%20gamer%20black%20jacket%20intense%20expression%2C%20neon%20gaming%20aesthetics%2C%20dark%20background%20digital%20particles%2C%20high%20contrast%2C%20sharp%20detailed%20linework&width=800&height=1000&seq=article-cover-03&orientation=portrait",
  4: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fantasy%20manga%20celestial%20being%20white%20red%20silk%20robes%20long%20dark%20hair%2C%20floating%20petals%20butterflies%2C%20golden%20light%2C%20soft%20gradient%20background%2C%20exquisite%20traditional%20style&width=800&height=1000&seq=article-cover-04&orientation=portrait",
  5: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20dark-haired%20hunter%20piercing%20blue%20eyes%20black%20combat%20outfit%2C%20ethereal%20blue%20holograms%2C%20dark%20gradient%20background%2C%20premium%20manhwa%20illustration%2C%20cinematic%20lighting&width=800&height=1000&seq=article-cover-05&orientation=portrait",
  6: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20Chinese%20manga%20futuristic%20soldier%20mechanical%20armor%20floating%20fortress%2C%20dramatic%20orange%20gray%20sky%2C%20sci-fi%20dystopian%2C%20dark%20industrial%2C%20mecha%20design%2C%20cinematic&width=800&height=1000&seq=article-cover-06&orientation=portrait",
  7: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20two%20cultivators%20black%20white%20robes%20playing%20guqin%20bamboo%20forest%2C%20ethereal%20mist%20moonlight%2C%20ink%20wash%20style%2C%20detailed%20character%20art%2C%20serene%20mood&width=800&height=1000&seq=article-cover-07&orientation=portrait",
  8: "https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20determined%20young%20swordsman%20burgundy%20hair%20blue%20nichirin%20blade%2C%20water%20breathing%20turquoise%20effect%2C%20dark%20background%20waves%2C%20iconic%20shonen%20style&width=800&height=1000&seq=article-cover-08&orientation=portrait",
  9: "https://readdy.ai/api/search-image?query=Romantic%20vampire%20manga%20handsome%20male%20vampire%20crimson%20eyes%20black%20attire%2C%20gentle%20girl%20white%20dress%2C%20gothic%20rose%20garden%2C%20moonlight%20deep%20red%20silver%2C%20exquisite%20shoujo%20art&width=800&height=1000&seq=article-cover-09&orientation=portrait",
  10: "https://readdy.ai/api/search-image?query=Epic%20xianxia%20manga%20young%20cultivator%20long%20hair%20mountain%20peak%2C%20mythical%20beasts%20clouds%2C%20golden%20sunrise%2C%20fantasy%20landscape%2C%20traditional%20Chinese%20ink%20painting%20modern%20manga&width=800&height=1000&seq=article-cover-10&orientation=portrait",
  11: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20spiky%20pink-haired%20teenager%20cursed%20energy%20purple%20black%2C%20urban%20Japanese%20night%20cityscape%2C%20neon%20accents%2C%20bold%20dynamic%20shonen%2C%20sharp%20angular%20linework&width=800&height=1000&seq=article-cover-11&orientation=portrait",
  12: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20beautiful%20girl%20flawless%20makeup%20transformation%20two%20handsome%20male%20leads%2C%20Korean%20high%20school%2C%20pastel%20pink%20coral%2C%20glamorous%20webtoon%20style&width=800&height=1000&seq=article-cover-12&orientation=portrait",
};

const relatedCoverImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20martial%20artist%20red%20robes%20flames%2C%20golden%20crimson%2C%20clean%20background%2C%20detailed%20illustration%2C%20dynamic%20composition&width=400&height=560&seq=related-cover-01&orientation=portrait",
  3: "https://readdy.ai/api/search-image?query=Action%20manga%20silver-haired%20gamer%20black%20jacket%2C%20neon%20gaming%20aesthetics%2C%20dark%20background%2C%20dynamic%20shonen%20art%2C%20high%20contrast&width=400&height=560&seq=related-cover-03&orientation=portrait",
  4: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fantasy%20manga%20celestial%20white%20red%20robes%2C%20petals%20butterflies%2C%20golden%20light%2C%20soft%20gradient%2C%20exquisite%20art&width=400&height=560&seq=related-cover-04&orientation=portrait",
  5: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark-haired%20hunter%20blue%20eyes%20black%20outfit%2C%20holograms%2C%20dark%20gradient%2C%20premium%20manhwa%20style%2C%20cinematic&width=400&height=560&seq=related-cover-05&orientation=portrait",
  6: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20manga%20futuristic%20soldier%20mechanical%20armor%2C%20dramatic%20sky%2C%20sci-fi%20dystopian%2C%20dark%20industrial%2C%20mecha%20design&width=400&height=560&seq=related-cover-06&orientation=portrait",
  7: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20two%20cultivators%20black%20white%20robes%2C%20bamboo%20forest%20moonlight%2C%20ink%20wash%20style%2C%20serene%20mood&width=400&height=560&seq=related-cover-07&orientation=portrait",
  8: "https://readdy.ai/api/search-image?query=Japanese%20manga%20swordsman%20burgundy%20hair%20blue%20blade%2C%20water%20breathing%2C%20dark%20background%2C%20iconic%20shonen%20style&width=400&height=560&seq=related-cover-08&orientation=portrait",
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const mangaId = parseInt(id || "0", 10);
  const manga = mangaList.find((m) => m.id === mangaId);

  if (!manga) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16 flex items-center justify-center bg-background-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 font-heading">漫画未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const category = mangaCategories.find((c) => c.slug === manga.category);
  const relatedManga = mangaList
    .filter((m) => m.category === manga.category && m.id !== manga.id)
    .slice(0, 4);
  const otherHot = mangaList
    .filter((m) => m.category !== manga.category)
    .slice(0, 4);

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <section className="py-8 md:py-12 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              {category && (
                <>
                  <Link to="/category/all" className="hover:text-primary-500 transition-colors cursor-pointer">{category.name}</Link>
                  <i className="ri-arrow-right-s-line"></i>
                </>
              )}
              <span className="text-foreground-600">{manga.title}</span>
            </nav>

            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="lg:w-[35%]">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-background-300 text-xs text-foreground-600 mb-6">
                  {category && (
                    <>
                      <i className={`${category.icon} text-primary-500 text-xs`}></i>
                      {category.name}
                    </>
                  )}
                </div>
                <div className="aspect-[3/4] rounded-2xl overflow-hidden">
                  {articleCoverImages[manga.id] && (
                    <img
                      src={articleCoverImages[manga.id]}
                      alt={manga.title}
                      title={`${manga.title} - 汗汗漫画`}
                      className="w-full h-full object-cover object-top"
                    />
                  )}
                </div>
              </div>

              <div className="lg:w-[65%] flex flex-col justify-center">
                <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-900 tracking-tight leading-tight">
                  {manga.title}
                </h1>
                <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-lg">
                  {manga.description}
                </p>

                <div className="mt-6 flex flex-wrap items-center gap-3 text-sm text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {manga.author}
                  </span>
                  <span className="text-foreground-300">|</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-400"></i>
                    {manga.rating} 分
                  </span>
                  <span className="text-foreground-300">|</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(manga.views / 10000).toFixed(0)}万 阅读
                  </span>
                  <span className="text-foreground-300">|</span>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                    {manga.status}
                  </span>
                </div>

                <p className="mt-4 text-sm text-foreground-400">
                  最新：{manga.latestChapter} · {manga.updateTime}
                </p>

                <div className="mt-8 flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl bg-foreground-900 text-white text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-book-open-line"></i>
                    开始阅读
                  </button>
                  <button
                    className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-xl border border-background-300 text-foreground-700 text-sm font-medium hover:text-primary-500 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-heart-line"></i>
                    加入收藏
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
              <div className="lg:w-[60%]">
                <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-8">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary-500 mr-2"></span>
                  读者热评
                </p>
                <blockquote>
                  <p className="font-serif text-xl md:text-2xl text-foreground-900 leading-relaxed italic">
                    &ldquo;{manga.title}真的是一部让人上头的漫画！从第一话开始就完全停不下来，剧情紧凑，画风精美，人物塑造非常立体。每次更新都第一时间追更，强烈推荐给还没看过的朋友！&rdquo;
                  </p>
                </blockquote>
                <div className="mt-5 flex items-center gap-3">
                  <span className="text-sm font-bold text-foreground-900 font-heading">漫画迷小陈</span>
                  <span className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs">
                    <i className="ri-shield-check-line text-xs"></i>
                    汗汗漫画认证读者
                  </span>
                </div>
                <div className="mt-4 flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                  ))}
                </div>
              </div>

              <div className="lg:w-[40%]">
                <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20portrait%20of%20young%20Asian%20person%20with%20glasses%2C%20shoulders%20above%2C%20thoughtful%20reading%20expression%2C%20pure%20white%20background%2C%20high%20contrast%20editorial%20style%2C%20clean%20minimal%20composition&width=600&height=800&seq=article-testimonial-portrait&orientation=portrait"
                    alt="读者评论"
                    title="汗汗漫画读者"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {(relatedManga.length > 0 || otherHot.length > 0) && (
          <section className="py-12 md:py-16 bg-background-50">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-8">
                猜你喜欢
              </h2>

              {relatedManga.length > 0 && (
                <div className="mb-10">
                  <p className="text-xs text-foreground-500 mb-4">同类推荐 · {category?.name}</p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
                    {relatedManga.map((m) => (
                      <Link
                        key={m.id}
                        to={`/article/${m.id}`}
                        className="group cursor-pointer"
                      >
                        <div className="aspect-[3/4] rounded-xl overflow-hidden mb-3">
                          {relatedCoverImages[m.id] && (
                            <img
                              src={relatedCoverImages[m.id]}
                              alt={m.title}
                              title={`${m.title} - 汗汗漫画`}
                              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                            />
                          )}
                        </div>
                        <h3 className="text-sm font-bold text-foreground-900 font-heading truncate">
                          {m.title}
                        </h3>
                        <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
                          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                          {m.rating}
                        </p>
                      </Link>
                    ))}
                  </div>
                </div>
              )}

              {otherHot.length > 0 && (
                <div>
                  <p className="text-xs text-foreground-500 mb-4">热门推荐</p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
                    {otherHot.map((m) => (
                      <Link
                        key={m.id}
                        to={`/article/${m.id}`}
                        className="group cursor-pointer"
                      >
                        <div className="aspect-[3/4] rounded-xl overflow-hidden mb-3">
                          {relatedCoverImages[m.id] && (
                            <img
                              src={relatedCoverImages[m.id]}
                              alt={m.title}
                              title={`${m.title} - 汗汗漫画`}
                              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                            />
                          )}
                        </div>
                        <h3 className="text-sm font-bold text-foreground-900 font-heading truncate">
                          {m.title}
                        </h3>
                        <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
                          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                          {m.rating}
                        </p>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": `${manga.title} - 汗汗漫画`,
            "description": manga.description,
            "author": {
              "@type": "Person",
              "name": manga.author
            },
            "datePublished": "2024-01-15T08:00:00+08:00",
            "dateModified": new Date().toISOString(),
            "url": `http://i0767.com/article/${manga.id}`,
            "inLanguage": "zh-Hans",
            "publisher": {
              "@type": "Organization",
              "name": "汗汗漫画",
              "url": "http://i0767.com/"
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "http://i0767.com/"
              },
              ...(category ? [{
                "@type": "ListItem",
                "position": 2,
                "name": category.name,
                "item": 'http://i0767.com/category/all'
              }] : []),
              {
                "@type": "ListItem",
                "position": category ? 3 : 2,
                "name": manga.title,
                "item": `http://i0767.com/article/${manga.id}`
              }
            ]
          }),
        }}
      />
    </>
  );
}